import { User } from '../models';
import { ImpersonatedCustomer } from '../types';

export function isUser(user: User | ImpersonatedCustomer): user is User {
  return !!(user as User).id;
}
